import {useState} from 'react';
import {useProfileData} from './hooks';
import {ProfileBoxPresentation} from './presentation';

export const ProfileBoxContainer: React.FC = () => {
  const {user, university, profile} = useProfileData();
  const [showCompletionIndicator, setShowCompletionIndicator] = useState(true);

  const handleCloseCompletionIndicator = () => {
    setShowCompletionIndicator(false);
  };

  return (
    <ProfileBoxPresentation
      user={user}
      university={university}
      profile={profile}
      showCompletionIndicator={showCompletionIndicator}
      onCloseCompletionIndicator={handleCloseCompletionIndicator}
    />
  );
};
